import { render } from "./AssessorListEditDrawer2.vue?vue&type=template&id=4f67de88&ts=true"
import script from "./AssessorListEditDrawer2.vue?vue&type=script&lang=ts"
export * from "./AssessorListEditDrawer2.vue?vue&type=script&lang=ts"

import "./AssessorListEditDrawer2.vue?vue&type=style&index=0&id=4f67de88&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__